// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"68":"result","771":"consult"}[chunkId] + "-legacy." + {"68":"f22c015f","771":"76df9242"}[chunkId] + ".js";
};